import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { OutletExtendedDataDTO, OutletLanguageDetails } from './model/outlet';
import { map, Observable, switchMap } from 'rxjs';
import { OutletCacheService } from '../../outlet-cache/outlet-cache.service';
import { OutletDTO, OutletRightsDTO } from '../../outlet-cache/model/outlet';

@Injectable({
  providedIn: 'root',
})
export class OutletService {
  constructor(
    private httpClient: HttpClient,
    private outletCacheService: OutletCacheService
  ) {}

  getOutletInformation(outletId: number): Observable<OutletExtendedDataDTO> {
    const url: string = `${environment.prestoUrl}/outlet/${outletId}`;
    return this.httpClient.get<OutletExtendedDataDTO>(url);
  }

  getSelectedOutletInformation(): Observable<OutletExtendedDataDTO> {
    return this.outletCacheService.getSelectedOutlet().pipe(
      switchMap((outletRights: OutletRightsDTO) =>
        this.getOutletInformation(outletRights.outlet.identity.id)
      ),
      map((outletDto: OutletExtendedDataDTO) => outletDto)
    );
  }

  getOutletsByUserRight(
    rightName: string
  ): Observable<Map<string, OutletDTO[]>> {
    let params = new HttpParams();
    params = params.append('rightName', rightName);
    const url: string = `${environment.prestoUrl}/outlet`;
    return this.httpClient.get<Map<string, OutletDTO[]>>(url, { params });
  }

  getOutletLanguagesById(
    outletIds: number[]
  ): Observable<OutletLanguageDetails[]> {
    let params = new HttpParams();
    params = params.append('outletId', outletIds.join(','));
    const url: string = `${environment.prestoUrl}/outlet/languages`;
    return this.httpClient.get<OutletLanguageDetails[]>(url, { params });
  }
}
